import typeToReducer from "type-to-reducer";

const initialState = null;

const reducer = typeToReducer(
  {
    START: (state, action) => null,
    SUCCESS: (state, action) => {
      if (action.payload && action.payload.entities && action.payload.result) {
        return {
          ...action.payload.entities,
          result: action.payload.result,
          pageCount: action.payload.pageCount
        };
      } else {
        return {
          error: "Something went Wrong"
        };
      }
    },
    ERROR: (state, action) => ({
      error: action.payload
    })
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/foodna.js